import { List } from 'immutable';

import * as Constants from '../constants';
import { UsageKeys } from '../constants/Usage';
import { type ValueOf } from '../types';

import { getDailySkipLimit, getStationSkipLimit, isListenerFlexSkip } from './ListenerUtils';

/**
 * Returns all skips for specified station as a list of UTC timestamps
 *
 * @param  {object} state - the state
 * @param  {string} stationId - the stationId to retrieve skips from
 * @returns {List} - List of skip UTC timestamps
 */
export function getCurrentListenerSkipsByStationId(state: $TSFixMe, stationId: string): $TSFixMe {
  return state.usage.getIn([UsageKeys.SKIP_USAGE, stationId], List());
}

/**
 * Reduces all skips accross all stations into one list of skips
 *
 * @param  {object} state - the state
 * @returns {List} - List of skip UTC timestamps
 */
export function getCurrentListenerSkips(state: $TSFixMe): List<$TSFixMe> {
  const usage = state.usage.get(UsageKeys.SKIP_USAGE, List());
  return usage.reduce((a: $TSFixMe, b: $TSFixMe) => {
    return a.concat(b);
    // @ts-expect-error TS(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  }, new List());
}

export function hasListenerReachedDailySkipLimit(state: $TSFixMe): boolean {
  const dailySkipLimit = getDailySkipLimit(state);
  const timesSkippedToday = getCurrentListenerSkips(state).filter((timestamp: $TSFixMe) => {
    return Date.now() - timestamp < Constants.App.DAILY_SKIP_TIMEOUT;
  }).size;

  return (
    dailySkipLimit !== Constants.App.NO_SKIP_LIMIT_SENTINEL && timesSkippedToday >= dailySkipLimit
  );
}

export function hasListenerReachedStationSkipLimit(state: $TSFixMe, stationId: string): boolean {
  const stationSkipLimit = getStationSkipLimit(state);
  const timesSkippedThisHour = getCurrentListenerSkipsByStationId(state, stationId).filter(
    (timestamp: $TSFixMe) => {
      return Date.now() - timestamp < Constants.App.HOURLY_SKIP_TIMEOUT;
    },
  ).size;

  return (
    stationSkipLimit !== Constants.App.NO_SKIP_LIMIT_SENTINEL &&
    timesSkippedThisHour >= stationSkipLimit
  );
}

export function hasListenerReachedAnySkipLimits(state: $TSFixMe, stationId: string): boolean {
  return (
    hasListenerReachedDailySkipLimit(state) || hasListenerReachedStationSkipLimit(state, stationId)
  );
}

export function getUnskippableTrackCoachmarkType(
  state: $TSFixMe,
  actionType: $TSFixMe,
): ValueOf<typeof Constants.MiniCoachmark.MiniCoachmarkTypes> {
  const hasFlex = isListenerFlexSkip(state);
  if (!hasFlex) {
    if (actionType === Constants.Playback.ActionTypes.TRACK_THUMBDOWN) {
      return Constants.MiniCoachmark.MiniCoachmarkTypes.THUMB_DOWN;
    } else if (actionType === Constants.UseCases.ActionTypes.SKIP_TRACK_FORWARD) {
      return Constants.MiniCoachmark.MiniCoachmarkTypes.SKIP_LIMIT_REACHED;
    }
  }
  return Constants.MiniCoachmark.MiniCoachmarkTypes.SKIP_LIMIT_REACHED_FLEX;
}
